export default {
  "feed_bottom_open_comment": {
    "HK": "開啟PUBG MOBILE查看更多評論",
    "TW": "開啟PUBG MOBILE查看更多評論",
    "ar_SA": "افتح PUBG MOBILE لعرض المزيد من التعليقات",
    "de_DE": "Öffne PUBG MOBILE, um mehr Kommentare zu sehen",
    "en_US": "Open PUBG MOBILE to view more comments",
    "es_ES": "Abre PUBG MOBILE para ver más comentarios",
    "fr_FR": "Ouvrez PUBG MOBILE pour voir plus de commentaires",
    "hi_IN": "Open PUBG MOBILE to view more comments",
    "in_ID": "Buka PUBG MOBILE untuk melihat lebih banyak komentar",
    "ja_JP": "Open PUBG MOBILE to view more comments",
    "ko_KR": "Open PUBG MOBILE to view more comments",
    "ms_MY": "Bukakan PUBG MOBILE untuk melihat lagi komen",
    "pt_PT": "Abra o PUBG MOBILE para ver mais comentários",
    "ru_RU": "Чтобы увидеть больше комментариев, откройте PUBG MOBILE",
    "th_TH": "เปิด PUBG MOBILE เพื่อดูความคิดเห็นเพิ่มเติม",
    "tr_TR": "Daha fazla yorum görmek için PUBG MOBILE'ı aç",
    "ur": "مزید تبصرے دیکھنے کے لیے PUBG MOBILE کھولیں",
    "uz": "Boshqa fikrlarni ko‘rish uchun PUBG MOBILE ilovasini oching",
    "vi_VN": "Vào PUBG MOBILE để xem thêm bình luận.",
    "zh_CN": "打开PUBG MOBILE查看更多评论"
  },
  "feed_club_desc": {
    "HK": "結交更多好友，討論交流，一起遊戲",
    "TW": "結交更多好友，討論交流，一起遊戲",
    "ar_SA": "تعرَّف على أصدقاء أكثر، ودردشوا والعبوا سويًا.",
    "de_DE": "Finde neue Freunde, diskutiert und spielt zusammen.",
    "en_US": "Make more friends, discuss and play together.",
    "es_ES": "Haz más amigos, debate y juega en equipo.",
    "fr_FR": "Faites-vous plus d'amis, discutez et jouez ensemble.",
    "hi_IN": "Make more friends, discuss and play together.",
    "in_ID": "Perbanyak teman, berdiskusi dan bermain bersama.",
    "ja_JP": "Make more friends, discuss and play together.",
    "ko_KR": "Make more friends, discuss and play together.",
    "ms_MY": "Kenali lebih ramai rakan, berbincang dan bermain bersama-sama.",
    "pt_PT": "Crie amizades, conversem e joguem juntos.",
    "ru_RU": "Заводите друзей, общайтесь и играйте вместе.",
    "th_TH": "ทำความรู้จักเพื่อนมากขึ้น, พูดคุย และเล่นเกมด้วยกัน",
    "tr_TR": "Daha çok arkadaş edin, birlikte tartışın ve oynayın.",
    "ur": "مزید دوست بنائیں، ان سے بات چیت کریں اور مل کر کھیلیں۔",
    "uz": "Koʻproq doʻstlar orttiring, muhokama qiling va birga oʻynang.",
    "vi_VN": "Làm quen nhiều bạn mới, thảo luận về game và cùng chơi với nhau.",
    "zh_CN": "发现更多好友，讨论交流，一起游戏"
  },
  "feed_club_title": {
    "HK": "俱樂部",
    "TW": "俱樂部",
    "ar_SA": "النادي",
    "de_DE": "Club",
    "en_US": "Club",
    "es_ES": "CLUB",
    "fr_FR": "Club",
    "hi_IN": "Club",
    "in_ID": "Klub",
    "ja_JP": "Club",
    "ko_KR": "Club",
    "ms_MY": "Kelab",
    "pt_PT": "CLUB",
    "ru_RU": "Клуб",
    "th_TH": "คลับ",
    "tr_TR": "Kulüp",
    "ur": "‏کلب",
    "uz": "Klub",
    "vi_VN": "Câu Lạc Bộ",
    "zh_CN": "俱乐部"
  },
  "feed_club_top_open": {
    "HK": "打開",
    "TW": "開啟",
    "ar_SA": "فتح",
    "de_DE": "Öffnen",
    "en_US": "Open",
    "es_ES": "Abrir",
    "fr_FR": "Ouvrir",
    "hi_IN": "Open",
    "in_ID": "Buka",
    "ja_JP": "Open",
    "ko_KR": "Open",
    "ms_MY": "Buka",
    "pt_PT": "Abrir",
    "ru_RU": "Открыть",
    "th_TH": "เปิด",
    "tr_TR": "Aç",
    "ur": "‏کھولیں",
    "uz": "Ochish",
    "vi_VN": "Mở",
    "zh_CN": "打开"
  },
  "feed_comments": {
    "HK": "評論",
    "TW": "評論",
    "ar_SA": "تعليقات",
    "de_DE": "Kommentare",
    "en_US": "Comments",
    "es_ES": "Comentarios",
    "fr_FR": "Commentaires",
    "hi_IN": "Comments",
    "in_ID": "Komentar",
    "ja_JP": "Comments",
    "ko_KR": "Comments",
    "ms_MY": "Komen",
    "pt_PT": "Comentários",
    "ru_RU": "Комментарии",
    "th_TH": "ความคิดเห็น",
    "tr_TR": "Yorumlar",
    "ur": "تبصرے",
    "uz": "Fikrlar",
    "vi_VN": "Bình Luận",
    "zh_CN": "评论"
  },
  "feed_join": {
    "HK": "加入",
    "TW": "加入",
    "ar_SA": "انضمام",
    "de_DE": "Teilnehmen",
    "en_US": "Join",
    "es_ES": "Unir",
    "fr_FR": "Rejoindre",
    "hi_IN": "Join",
    "in_ID": "Ikuti",
    "ja_JP": "Join",
    "ko_KR": "Join",
    "ms_MY": "Sertai",
    "pt_PT": "Participar",
    "ru_RU": "Участвовать",
    "th_TH": "เข้าร่วม",
    "tr_TR": "Katıl",
    "ur": "‏شامل ہوں",
    "uz": "Qoʻshilish",
    "vi_VN": "Tham Gia",
    "zh_CN": "加入"
  },
  "feed_joined": {
    "HK": "已加入",
    "TW": "已加入",
    "ar_SA": "تم الانضمام",
    "de_DE": "Beigetreten",
    "en_US": "Joined",
    "es_ES": "Ya se unió",
    "fr_FR": "A rejoint",
    "hi_IN": "Joined",
    "in_ID": "bergabung",
    "ja_JP": "Joined",
    "ko_KR": "Joined",
    "ms_MY": "Disertai",
    "pt_PT": "Entrou",
    "ru_RU": "Иду",
    "th_TH": "เข้าร่วมแล้ว",
    "tr_TR": "Katıldın",
    "ur": "شامل ہو گئے",
    "uz": "Qoʻshildi",
    "vi_VN": "Đã tham gia",
    "zh_CN": "已加入"
  },
  "feed_time_hour": {
    "HK": "%s小時前",
    "TW": "%s小時前",
    "ar_SA": "منذ %s س",
    "de_DE": "%sh",
    "en_US": "%s h",
    "es_ES": "%s h",
    "fr_FR": "%s h",
    "hi_IN": "%s h",
    "in_ID": "%s jam yang lalu",
    "ja_JP": "%s h",
    "ko_KR": "%s h",
    "ms_MY": "%s j lalu",
    "pt_PT": "%s h",
    "ru_RU": "%s ч. назад",
    "th_TH": "%s ชั่วโมงก่อน",
    "tr_TR": "%ss önce",
    "ur": "‏%s گھنٹے",
    "uz": "%s soat",
    "vi_VN": "%s giờ trước",
    "zh_CN": "%s小时前"
  },
  "feed_time_min": {
    "HK": "%s分鐘前",
    "TW": "%s分鐘前",
    "ar_SA": "منذ %s د",
    "de_DE": "%sm",
    "en_US": "%s m",
    "es_ES": "%s m",
    "fr_FR": "%s m",
    "hi_IN": "%s m",
    "in_ID": "%s menit yang lalu",
    "ja_JP": "%s m",
    "ko_KR": "%s m",
    "ms_MY": "%s m lalu",
    "pt_PT": "%s m",
    "ru_RU": "%s мин. назад",
    "th_TH": "%s นาทีก่อน",
    "tr_TR": "%sdk önce",
    "ur": "‏%s منٹ",
    "uz": "%s daq",
    "vi_VN": "%s phút trước",
    "zh_CN": "%s分钟前"
  },
  "feed_time_now": {
    "HK": "剛剛",
    "TW": "剛剛",
    "ar_SA": "الآن",
    "de_DE": "Jetzt gerade",
    "en_US": "Just now",
    "es_ES": "Ahora mismo",
    "fr_FR": "À l'instant",
    "hi_IN": "Just now",
    "in_ID": "Baru saja",
    "ja_JP": "Just now",
    "ko_KR": "Just now",
    "ms_MY": "Sebentar tadi",
    "pt_PT": "Agora mesmo",
    "ru_RU": "Только что",
    "th_TH": "เมื่อสักครู่",
    "tr_TR": "Hemen şimdi",
    "ur": "بالکل ابھی",
    "uz": "Hozir",
    "vi_VN": "Vừa xong",
    "zh_CN": "刚刚"
  },
  "feed_title": {
    "HK": "帖子詳情",
    "TW": "貼文詳情",
    "ar_SA": "تفاصيل المنشور",
    "de_DE": "Postdetails",
    "en_US": "Post Detail",
    "es_ES": "Detalles de la publicación",
    "fr_FR": "Infos du billet",
    "hi_IN": "Post Detail",
    "in_ID": "Detil Posting",
    "ja_JP": "Post Detail",
    "ko_KR": "Post Detail",
    "ms_MY": "Butiran Siaran",
    "pt_PT": "Detalhes da Publicação",
    "ru_RU": "Сведения о публикации",
    "th_TH": "รายละเอียดการโพสต์",
    "tr_TR": "Gönderi Ayrıntıları",
    "ur": "پوسٹ کی تفصیل",
    "uz": "Post tafsilotlari",
    "vi_VN": "Chi Tiết Bài Đăng",
    "zh_CN": "帖子详情"
  },
  "topic_hot_post": {
    "HK": "熱門帖子",
    "TW": "熱門貼文",
    "ar_SA": "الرائجة",
    "de_DE": "Angesagt",
    "en_US": "Trending",
    "es_ES": "Tendencia",
    "fr_FR": "Tendances",
    "hi_IN": "Trending",
    "in_ID": "Trending",
    "ja_JP": "Trending",
    "ko_KR": "Trending",
    "ms_MY": "Popular",
    "pt_PT": "Em Alta",
    "ru_RU": "Популярное",
    "th_TH": "มาแรง",
    "tr_TR": "Revaçta",
    "ur": "ٹرینڈنگ",
    "uz": "Trendda",
    "vi_VN": "Hot",
    "zh_CN": "热门帖子"
  },
  "topic_join_num": {
    "HK": "%s人參與討論",
    "TW": "%s人參與討論",
    "ar_SA": "%s من اللاعبين يتناقشون",
    "de_DE": "Diskutierende Spieler: %s",
    "en_US": "%s players discussing",
    "es_ES": "%s jugadores están conversando",
    "fr_FR": "%s joueurs en parlent",
    "hi_IN": "%s players discussing",
    "in_ID": "%s pemain membahas",
    "ja_JP": "%s players discussing",
    "ko_KR": "%s players discussing",
    "ms_MY": "%s pemain berbincang",
    "pt_PT": "%s jogadores discutindo",
    "ru_RU": "Участвуют в обсуждении: %s",
    "th_TH": "ผู้เล่น %s คนกำลังพูดคุย",
    "tr_TR": "%s oyuncu tartışıyor",
    "ur": "‏%s پلیئرز گفتگو کر رہے ہیں",
    "uz": "%s nafa o‘yinchi muhokama qilmoqda",
    "vi_VN": "%s người chơi đang thảo luận",
    "zh_CN": "%s人参与讨论"
  },
  "topic_title": {
    "HK": "話題分享",
    "TW": "話題分享",
    "ar_SA": "مشاركة موضوع",
    "de_DE": "Thema teilen",
    "en_US": "Share Topic",
    "es_ES": "Compartir el tema",
    "fr_FR": "Partage de sujet",
    "hi_IN": "Share Topic",
    "in_ID": "Bagikan Topik",
    "ja_JP": "Share Topic",
    "ko_KR": "Share Topic",
    "ms_MY": "Kongsi Topik",
    "pt_PT": "Compartilhar Tópico",
    "ru_RU": "Поделиться темой",
    "th_TH": "แชร์หัวข้อ",
    "tr_TR": "Konuyu Paylaş",
    "ur": "موضوع شیئر کریں",
    "uz": "Mavzu ulashish",
    "vi_VN": "Chia Sẻ Chủ Đề",
    "zh_CN": "话题分享"
  }
}